function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import { useState, useEffect } from 'react';
/**
 * 요소의 가로 너비를 감시하여 컴팩트 모드 여부를 반환하는 커스텀 훅
 * @param ref 감시할 HTML 엘리먼트의 ref
 * @param threshold 컴팩트 모드로 전환될 임계값 (픽셀)
 * @returns 현재 요소가 컴팩트 모드인지 여부
 */ export var useElementWidth = function(ref, threshold) {
    var _useState = _sliced_to_array(useState(false), 2), isCompact = _useState[0], setIsCompact = _useState[1];
    useEffect(function() {
        var element = ref.current;
        if (!element) return;
        // ResizeObserver를 사용하여 요소 크기 변화 감지
        var resizeObserver = new ResizeObserver(function(entries) {
            var entry = entries[0];
            setIsCompact(entry.contentRect.width < threshold);
        });
        resizeObserver.observe(element);
        // 클린업 함수
        return function() {
            return resizeObserver.disconnect();
        };
    }, [
        threshold
    ]);
    return isCompact;
};
